import { createReducer } from 'store/createReducer';
import { LoadingStatus } from 'models/LoadingStatus';
import { EditorialPageModel } from 'models/EditorialPageModel';
import { SET_EDITORIALS, ADD_EDITORIALS, RESTORE_EDITORIALS, SetEditorialsAction } from './actions';

const defaultPageState = {
  meta: {
    title: '',
    tags: {},
    links: {},
    experiments: [],
    openGraphTags: {}
  },
  componentName: '_noComponent',
  status: LoadingStatus.Loading,
  webCatalog: '',
  breadCrumbs: [],
  fullPageLoad: false,
  runningExperiments: {},
  menuAds: {},
  pageTopContentArea: { content: [] },
  content: [],
  editorials: [],
  group: '',
  articleFilter: '',
  totalCount: 0,
  nextPage: 0,
  pageName: '',
  menu: []
} as EditorialPageModel;

export default createReducer(defaultPageState, {
  [SET_EDITORIALS]: (state, { editorials, nextPage }: SetEditorialsAction) => ({
    ...state,
    editorials,
    nextPage: nextPage + 1
  }),
  [ADD_EDITORIALS]: (state, { editorials, nextPage }: SetEditorialsAction) => ({
    ...state,
    editorials: [...state.editorials, ...editorials],
    nextPage: nextPage + 1
  }),
  [RESTORE_EDITORIALS]: (state, { editorials }: SetEditorialsAction) => ({
    ...state,
    editorials
  })
});
